import { ChessTermType, MoveType, } from "@chesshotel/types";
import { detectLeaveUndefended, } from "./sacrifice.js";
export function isGreatMove(bestMoveScore, secondBestMoveScore) {
    const threshold = 1.1;
    const onlyGoodMove = Math.abs(bestMoveScore - secondBestMoveScore) > threshold;
    const notCompletelyWinning = Math.abs(bestMoveScore) < 5.5;
    return onlyGoodMove && notCompletelyWinning;
}
export function detectGreatMove(position, lastPosition) {
    if (position.moveType !== MoveType.BEST &&
        position.moveType !== MoveType.GREAT) {
        return null;
    }
    const { score, secondBestScore, mateInMoves } = lastPosition;
    const whiteToMove = position.moveIndex % 2 === 1;
    const isLoosing = (whiteToMove && score < 0) || (!whiteToMove && score > 0);
    const retakeMove = position.chessTerm?.term === ChessTermType.RETAKE ||
        position.chessTerm?.term === ChessTermType.TAKES_BACK;
    const moveToSafety = position.chessTerms?.some((chessTerm) => chessTerm.term === ChessTermType.MOVE_TO_SAFETY ||
        chessTerm.term === ChessTermType.IN_CHECK_MOVE_TO_SAFETY ||
        chessTerm.term === ChessTermType.IN_CHECK_BLOCK ||
        chessTerm.term === ChessTermType.IN_CHECK_ESCAPE ||
        chessTerm.term === ChessTermType.DEFEND ||
        chessTerm.term === ChessTermType.BLOCK ||
        chessTerm.term === ChessTermType.TRADE);
    const directMaterialWin = position.chessTerms?.some((chessTerm) => chessTerm.term === ChessTermType.DIRECT_MATERIAL_WIN ||
        chessTerm.term === ChessTermType.HANGING);
    if (isLoosing || retakeMove || moveToSafety || directMaterialWin) {
        return null;
    }
    const isGreat = isGreatMove(score, secondBestScore);
    const completelyWinning = Math.abs(score) >= 5.5;
    if (isGreat && mateInMoves == null && !completelyWinning) {
        position.moveType = MoveType.GREAT;
    }
}
export function detectBrilliantMove(position, lastPosition) {
    if (position.moveType === MoveType.BEST ||
        position.moveType === MoveType.EXCELLENT ||
        position.moveType === MoveType.GREAT) {
        const { score, mateInMoves } = lastPosition;
        const whiteToMove = position.moveIndex % 2 === 1;
        const isLoosing = (whiteToMove && score < 0) || (!whiteToMove && score > 0);
        const completelyWinning = Math.abs(score) >= 5.5;
        if (isLoosing || completelyWinning) {
            return null;
        }
        const sacrifice = position.chessTerm?.term == ChessTermType.SACRIFICE;
        const ignoreThreat = detectLeaveUndefended(lastPosition.fen, position.move);
        if (sacrifice || ignoreThreat) {
            position.moveType = MoveType.BRILLIANT;
        }
    }
}
//# sourceMappingURL=greatBrilliantMove.js.map